import React from "react";
import { Layout, styles } from "../../../layout"; // adjust path as needed

const DayUpdate: React.FC = () => {
  return (
    <Layout title="Day Logger Update">
      <p style={styles.paragraph}>
        This was a simple day-logging tool I built. I created a custom Shortcut
        on my iPhone that let me submit a quick daily update — the idea was to
        track the time I woke up in a Google Sheet.
      </p>

      <p style={styles.paragraph}>
        I didn’t actually use it that much, but I did learn how to:
      </p>

      <ul style={styles.list}>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>
          Set up and connect the Google Sheets API
        </li>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>
          Use Google Cloud Console to manage credentials and enable APIs
        </li>
        <li style={styles.listItem}>
          <span style={styles.bulletIcon}>•</span>
          Use Apps Script to append data automatically to a spreadsheet
        </li>
      </ul>
    </Layout>
  );
};

export default DayUpdate;
